export const strCreditKeyLocalStoragePageSize = 'credit-page-size';
export const strCreditKeyLocalStorageSort = 'credit-sort-favorite';
export const strCreditState = 'credit-state';
export const strCurrentTabLink = 'invoice-current-tab-link';
export const strInvoiceKeyLocalStoragePageSize = 'invoice-page-size';
export const strInvoiceKeyLocalStorageSort = 'invoice-sort-favorite';
export const strInvoiceState = 'invoice-state';
export const strPeriodSearchTypeFavorite = 'invoice-period-search-type-favorite';
export const strProFormaKeyLocalStoragePageSize = 'pro-forma-page-size';
export const strProFormaKeyLocalStorageSort = 'pro-forma-sort-favorite';
export const strProFormaState = 'pro-forma-state';
